import { render, staticRenderFns } from "./LicenseOverview.vue?vue&type=template&id=20dc5d29&scoped=true"
import script from "./LicenseOverview.vue?vue&type=script&lang=js"
export * from "./LicenseOverview.vue?vue&type=script&lang=js"
import style0 from "./LicenseOverview.vue?vue&type=style&index=0&id=20dc5d29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc5d29",
  null
  
)

export default component.exports